import { z } from 'zod';
import { paginationQuery } from './common.js';
/* ------------------------------------------------------------------ */
/* Módulo Proyectos (fase 3): liquidaciones (pago del saldo de un      */
/* periodo de planilla). No es la liquidación laboral por despido.     */
/* ------------------------------------------------------------------ */
export const SETTLEMENT_STATUSES = [
    { code: 'draft', name: 'Borrador' },
    { code: 'closed', name: 'Cerrada' },
    { code: 'reverted', name: 'Revertida' },
];
export const settlementStatus = z.enum(['draft', 'closed', 'reverted']);
/** Largo máximo de un periodo (medio año): una liquidación es semanal, quincenal o mensual. */
export const SETTLEMENT_MAX_DAYS = 186;
const isoDate = z.iso.date('Fecha inválida');
const optionalText = (max) => z.string().trim().max(max).nullable().optional();
function rangeIssues(v, ctx) {
    if (v.from > v.to) {
        ctx.addIssue({ code: 'custom', path: ['to'], message: 'El final debe ser posterior al inicio' });
        return;
    }
    if ((Date.parse(v.to) - Date.parse(v.from)) / 86_400_000 + 1 > SETTLEMENT_MAX_DAYS) {
        ctx.addIssue({ code: 'custom', path: ['to'], message: 'Un periodo abarca como máximo seis meses' });
    }
}
export const settlementPreviewQuery = z.object({ from: isoDate, to: isoDate }).superRefine(rangeIssues);
/**
 * Lo que se le paga a un trabajador en el periodo. Sin monto (`null`) se paga TODO el saldo que tenga al cerrar;
 * con monto, un pago parcial (entre 0 y el saldo): el resto queda como saldo anterior del siguiente periodo.
 */
export const settlementLineInput = z.object({
    assignmentId: z.uuid(),
    amount: z.coerce.number().min(0, 'No puede ser negativo').max(1e12, 'Monto inválido').nullable().optional(),
    notes: optionalText(300),
});
/** Crea o reemplaza un borrador. Los montos se recalculan en el servidor; el cliente solo elige cuánto pagar. */
export const settlementInput = z
    .object({
    from: isoDate,
    to: isoDate,
    notes: optionalText(1000),
    lines: z.array(settlementLineInput).max(500, 'Demasiados trabajadores').default([]),
})
    .superRefine((v, ctx) => {
    rangeIssues(v, ctx);
    const seen = new Set();
    for (const [i, line] of v.lines.entries()) {
        if (seen.has(line.assignmentId)) {
            ctx.addIssue({ code: 'custom', path: ['lines', i], message: 'Trabajador repetido' });
        }
        seen.add(line.assignmentId);
    }
});
export const settlementRevertInput = z.object({
    reason: z
        .string()
        .trim()
        .min(5, 'Contá brevemente por qué se revierte (mínimo 5 caracteres)')
        .max(500, 'Máximo 500 caracteres'),
});
export const settlementListQuery = paginationQuery.extend({
    projectId: z.uuid().optional(),
    status: settlementStatus.optional(),
    /** Periodos que se cruzan con el rango (por sus fechas, no por la fecha de cierre). */
    from: isoDate.optional(),
    to: isoDate.optional(),
});
//# sourceMappingURL=settlements.js.map